import { render, staticRenderFns } from "./FrontRightHandlebar.vue?vue&type=template&id=24f8bf98"
import script from "./FrontRightHandlebar.vue?vue&type=script&lang=js"
export * from "./FrontRightHandlebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports